import { useEffect } from "react";

const useZendesk = () => {
  useEffect(() => {
    let hasLoaded = false;

    const loadZendesk = () => {
      if (hasLoaded || document.getElementById("ze-snippet")) return;
      hasLoaded = true;

      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = "https://static.zdassets.com/ekr/snippet.js?key=2057b5ff-fdaf-4468-830b-b52ed9ebf8a7";
      script.async = true;
      document.head.appendChild(script);
    };

    const onUserInteraction = () => {
      loadZendesk();
      window.removeEventListener("scroll", onUserInteraction);
      window.removeEventListener("mousemove", onUserInteraction);
      window.removeEventListener("touchstart", onUserInteraction);
    };

    window.addEventListener("scroll", onUserInteraction);
    window.addEventListener("mousemove", onUserInteraction);
    window.addEventListener("touchstart", onUserInteraction);

    return () => {
      window.removeEventListener("scroll", onUserInteraction);
      window.removeEventListener("mousemove", onUserInteraction);
      window.removeEventListener("touchstart", onUserInteraction);
    };
  }, []);
};

export default useZendesk;
